import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { TranslateModule } from '@ngx-translate/core';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { AuthGuard } from '../pages/authentication/guards/auth.guards';
import { HomeComponent } from './home.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeIframeComponent } from './home-iframe/home-iframe.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { FLATPICKR_OPCOES_PADRAO } from 'app/utils/flatpickr-data-estrita';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxPermissionsModule } from 'ngx-permissions';
import { HomeAgenciamentoCargaComponent } from './home-agenciamento-carga/home-agenciamento-carga.component';
import { HomeAgenciamentoCargaPadraoComponent } from './home-agenciamento-carga-padrao/home-agenciamento-carga-padrao.component';
import { HomeTransporteRodoviarioComponent } from './home-transporte-rodoviario/home-transporte-rodoviario.component';
import { GoogleMapsModule } from '@angular/google-maps';

const routes = [
  {
    path: 'home',
    canActivate: [AuthGuard],
    component: HomeComponent,
    data: { animation: 'home' }
  }
];


@NgModule({
  declarations: [
    HomeComponent,
    HomeIframeComponent,
    HomeAgenciamentoCargaComponent,
    HomeAgenciamentoCargaPadraoComponent,
    HomeTransporteRodoviarioComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    TranslateModule,
    NgbNavModule,
    CoreCommonModule,
    NgApexchartsModule,
     NgbDropdownModule,
     NgxPermissionsModule,
     GoogleMapsModule,
    FlatpickrModule.forRoot(FLATPICKR_OPCOES_PADRAO),
  ],
  exports: [HomeComponent]
})
export class HomeModule { }
